var scope_0 = require('D:/Documents/React Projects/components/react-mui-draft-wysiwyg/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/003f4bb1179bd0afc0bc921edc8b96bc.js').default;

var scope_1 = require('D:/Documents/React Projects/components/react-mui-draft-wysiwyg/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/118f49365234cfd2b35d10cced2340a3.js').default;

var scope_2 = require('D:/Documents/React Projects/components/react-mui-draft-wysiwyg/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2146ef798576bf3b4c0a0b5c89c4c73c.js').default;

var scope_3 = require('D:/Documents/React Projects/components/react-mui-draft-wysiwyg/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/45c01475ea6755797a5b3a0236efa225.js').default;

var scope_4 = require('D:/Documents/React Projects/components/react-mui-draft-wysiwyg/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ae0db0e9431feb01b1154018290e4731.js').default;

var scope_5 = require('D:/Documents/React Projects/components/react-mui-draft-wysiwyg/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b9be8aed778a0d47f0d6900922685c4f.js').default;

var scope_6 = require('D:/Documents/React Projects/components/react-mui-draft-wysiwyg/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e13bafe53dc0eadebd9d76640baefbdc.js').default;

var scope_7 = require('D:/Documents/React Projects/components/react-mui-draft-wysiwyg/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}